import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { GanttTimeline } from './components/GanttTimeline';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { ComeFunzionaSection } from './components/ComeFunzionaSection';
import { SavingsCalculator } from './components/SavingsCalculator';
import { MaintenanceSection } from './components/MaintenanceSection';
import { IntegrationsSection } from './components/IntegrationsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col w-full bg-page-bg" data-id="element-0">
      <Navbar data-id="element-1" />

      <main className="flex-grow flex flex-col w-full" data-id="element-2">
        <HeroSection data-id="element-3" />

        <GanttTimeline data-id="element-4" />

        <NeighborhoodMap data-id="element-5" />

        <ComeFunzionaSection data-id="element-6" />

        <SavingsCalculator data-id="element-7" />

        <MaintenanceSection data-id="element-8" />

        <IntegrationsSection data-id="element-9" />

        <CtaSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}